module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "more"
    }
  }, [_c('h2', [_vm._v("More")]), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n    To see and edit confirmed matches, "), _c('router-link', {
    attrs: {
      "to": "/confirmed"
    }
  }, [_vm._v("click here")]), _vm._v(". Clean data helps ensure a reliable algorithm.\n    ")], 1), _vm._v(" "), _c('p', [_vm._v("\n      Face not showing up? "), _c('a', {
    attrs: {
      "href": "#/more"
    },
    on: {
      "click": _vm.forceRefresh
    }
  }, [_vm._v("Force refresh")]), _vm._v(".\n    ")]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/domainselector"
    }
  }, [_vm._v("Domain and Face Height Selector")])], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/matched"
    }
  }, [_vm._v("Faces Matched")]), _vm._v(" debugging tool\n    ")], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/modelvalidator"
    }
  }, [_vm._v("Model Validator")]), _vm._v(" debugging tool\n    ")], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/faceimages"
    }
  }, [_vm._v("Face Images")]), _vm._v(" debugging tool\n    ")], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/facesimilarity"
    }
  }, [_vm._v("Structural Similarity")]), _vm._v(" debugging tool\n    ")], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/clahevalidator"
    }
  }, [_vm._v("Clahe Validator")]), _vm._v(" debugging tool\n    ")], 1)]) : _c('div', [_vm._v("\n    To start, please "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("log in")]), _vm._v(".\n  ")], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      If you need assistance, please reach out to us at "), _c('a', {
    attrs: {
      "href": "tel:+18336926925"
    }
  }, [_vm._v("(833) NYC-OWAL")]), _vm._v(" (833) 692-6925.\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94f0b136","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/More.vue
// module id = 307
// module chunks = 1